import JobListingTableOfContents from "./JobListingTableOfContents";

export default JobListingTableOfContents;